import { render, staticRenderFns } from "./SUpload.vue?vue&type=template&id=2f6ba776&scoped=true&"
import script from "./SUpload.vue?vue&type=script&lang=ts&"
export * from "./SUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SUpload.vue?vue&type=style&index=0&id=2f6ba776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ba776",
  null
  
)

export default component.exports